/**
 * Created by claudio iozzia on 07/07/2017.
 */

export class Range {
  public static fullRange: Range = new Range();

  private _min: number;
  private _max: number;

  constructor(min: number = Number.NEGATIVE_INFINITY, max: number = Number.POSITIVE_INFINITY, autoSafe: boolean = true) {
    this._min = min;
    this._max = max;

    if (autoSafe === true && min > max) {
      this._min = max;
      this._max = min;
    }
  }

  public  get isEmpty(): boolean  { return this.min > this.max; }
  public  get isNumber(): boolean { return this.min === this.max; }

  public  get min(): number { return this._min; }
  public  get max(): number { return this._max; }

  public  safeRange(): Range { return new Range(this.min, this.max, true); }

  public  contains(v: number): boolean { return this.whereIs(v) === 0; }

  public  whereIs(v: number): number {
    if ( v < this.min ) {return -1; } // BELOW, UNDER...
    if ( this.max < v ) {return  1; } // ABOVE, OVER...
    return 0;                // WITHIN, INSIDE...
  }

  public intersect(that: Range): Range {
    return new Range( Math.max(this.min, that.min)
      , Math.min(this.max, that.max)
      , false);
  }
// public function union(that: Range): Range {
//  return new Range( Math.min(this.min, that.min)
//            , Math.max(this.max, that.max)
//            , false);
// }

  public get ofInt(): Range { return new Range(Math.ceil(this.min), Math.floor(this.max)); }

  public static extendedRange(a: number, b: number): Range {
    function orElse(ax: number, bx: number): number {
      return isFinite(ax) ? ax : bx;
    }

    return new Range(orElse(a, Number.NEGATIVE_INFINITY), orElse(b, Number.POSITIVE_INFINITY), false);
  }

  public intersectNotEmpty(that: Range): Range {
    return that.isEmpty ? this : this.intersect(that);
  }
}
